<template>
  <div class="opinion_modal active">
    <div class="opinion_con">
      <!-- <strong> -->
      최상위 부서를 선택하셨습니다.<br />
      최상위 부서를 선택했을 경우 대량메일이 발송될 위험이 있습니다.<br />
      계속 진행하시겠습니까?
      <!-- </strong> -->
      <div class="text_con"></div>
      <div>
        <span class="impor_mo_btn" @click="close(true)">{{ lang.ok }}</span>
        <span class="modal_cancel" @click="close(false)">{{
          lang.cancle
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    confirm: Object,
  },
  created() {
    this.lang = this.GetBookL.comment;
    // this.currentlang = this.GetBookL.report.repeatedit;
  },
  data() {
    return { currnetOrReapeat: "current" };
  },
  methods: {
    close(v) {
      if (v) {
        //확인
        this.$emit(this.confirm.do, this.confirm.param);
      }
      //취소s
      this.$emit("close");
    },
    current(v) {
      this.currnetOrReapeat = v;
    },
  },
};
</script>

<style scoped>
.opinion_con {
  text-align: center;
  height: 9rem;
}
.opinion_con > strong {
  border-bottom: none;
}
</style>